import { parseSortOrder } from './sort';

interface SortHeaderProps {
    column: string;
    order: string;
    onSort(column: string): void;
    children: React.ReactNode;
    align?: 'left' | 'right';
    // Full name of the column for assistive technology and tooltips.
    title?: string;
    className?: string;
}

// A table header cell that sorts by its column when pressed and shows the
// current direction.
export function SortHeader({ column, order, onSort, children, align = 'right', title, className }: SortHeaderProps) {
    const parsed = parseSortOrder(order);
    const active = parsed.column === column;

    return (
        <th
            scope="col"
            className={[align === 'left' ? 'left' : undefined, active ? 'sorted' : undefined, className].filter(Boolean).join(' ')}
            aria-sort={active ? (parsed.direction === 'Asc' ? 'ascending' : 'descending') : undefined}
        >
            <button type="button" title={title} onClick={() => onSort(column)}>
                {children}
                {active && <span aria-hidden="true" className="sort-mark">{parsed.direction === 'Asc' ? '▴' : '▾'}</span>}
            </button>
        </th>
    );
}
